import { getUrlParam } from "@/utils/util";
const axios = require("axios");
const getUserData = (token) => {
  return new Promise((resolve, reject) => {
    axios.get(`https://uappweb.huolala.cn/index.php?_m=user&_a=get_user_info&token=${token}`)
      .then(function (response) {
        if (response.data.ret === 0) {
          let data = {
            nickName: response.data.data.nickname,
            phone: response.data.data.phone_no
          }
          resolve(data)
        } else {
          reject(response)
        }
      })
      .catch(function (error) {
        reject(error)
      })
  })
}
const sjUserData = (token) => {
  return new Promise((resolve, reject) => {
    axios.get(`https://dappweb-api.huolala.cn/index.php?_m=driver&_a=get_user_info&token=${token}`)
      .then(function (response) {
        if (response.data.ret === 0) {
          let data = {
            nickName: response.data.data.nickname,
            phone: response.data.data.phone_no,
            driverId: response.data.data.driver_id || ''
          }
          resolve(data)
        } else {
          resolve(response)
        }
      })
      .catch(function (error) {
        resolve(error)
      })
  })
}
const getAppUserData = async function () {
  let _token = getUrlParam("_token")
  let data = {}
  // 用户端
  if (_token) {
    let userData = await getUserData(_token)
    if (userData.phone) Object.assign(data, userData)
  }
  return data;
}
export default getAppUserData
